<template>
  <div
    class="full-height"
  >
    <loader
      v-if="$wait.is('loading reported comments')"
    />

    <template
      v-else
    >
      <div
        v-if="comments.length <= 0"
      >
        <p
          class="mb-0 text-center font-italic mt-12"
        >
          Ei ilmiannettuja kommentteja
        </p>
      </div>

      <template
        v-else
      >
        <div
          class="full-height d-flex flex-column justify-space-between"
        >
          <div>
            <router-link
              :to="{
            name: 'single-post',
            params: {
              commentableId: comment.commentableId,
              commentsPerPage: -1,
            },
          }"
              style="text-decoration: none;"
            >
              <comment
                :comment="comment"
                hide-menu
                hide-like
              />
            </router-link>

            <div
              class="mt-2 caption"
            >
              <div
                v-for="(report, i) in comment.reports"
                :key="report.id"
              >
                <div>
                  Raportti {{ i + 1 }}: {{ reportingReasons[report.reason].fi }}
                </div>

                <div
                  v-if="report.records && report.records.length > 0"
                >
                  Onko ilmiannettu julkaisu sama kuin jokin näistä?
                  <v-img
                    v-for="(record, i) in report.records"
                    :key="i"
                    :src="record.imageSrc"
                    class="mb-1"
                  />
                </div>
              </div>
            </div>
          </div>

          <div
            class="d-flex flex-column"
          >
            <v-btn
              color="teal"
              dark
              tile
              class="mt-3 py-5"
              @click="approve"
            >
              Hyväksy
            </v-btn>

            <v-btn
              color="orange darken-1"
              dark
              tile
              class="mt-3 py-5"
              @click="destroy"
            >
              Poista kuva
            </v-btn>

            <v-btn
              color="error"
              tile
              class="mt-3 py-5"
              @click="destroyAndMute"
            >
              Poista kuva,
              <br>
              hiljennä OP viikoksi
            </v-btn>

            <v-btn
              color="error darken-2"
              tile
              class="mt-3 py-5"
              @click="muteReporter"
            >
              Hiljennä ilmiantaja
            </v-btn>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import { mapWaitingActions } from 'vue-wait';
import Comment from './Comment.vue';
import { reportingReasons } from '@/constants/reportingReasons';
import Loader from '@/components/Loader.vue';

export default {
  components: {
    Loader,
    Comment,
  },

  computed: {
    ...mapGetters({
      comments: 'comments/comments',
    }),

    comment() {
      return this.comments[0];
    },
  },

  created() {
    this.loadReportedComments();
  },

  beforeDestroy() {
    this.clearComments();
  },

  data: () => ({
    reportingReasons,
  }),

  methods: {
    ...mapWaitingActions('comments', {
      loadReportedComments: 'loading reported comments',
      clearComments: 'clearing comments',
    }),

    ...mapWaitingActions('admin/verdicts', {
      createVerdict: 'creating verdict',
    }),

    ...mapWaitingActions('users', {
      muteUserByCommentId: 'muting user',
    }),

    createVerdictWith(status) {
      this.createVerdict({
        id: this.comment.id,
        payload: {
          reportableType: this.comment.recordType,
          verdict: {
            status,
          },
        },
      });
    },

    destroy() {
      this.createVerdictWith('hidden');
    },

    destroyAndMute() {
      this.createVerdictWith('hidden_and_owner_muted');
    },

    muteReporter() {
      this.createVerdictWith('reporter_muted');
    },

    approve() {
      this.createVerdictWith('approved');
    },
  },
};
</script>
